// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ha6k","col":"styles_col__137dm"};